import React from 'react';
import { motion } from 'framer-motion';
export function SuccessCases() {
  const cases = [{
    stat: '+40%',
    business: 'Barbería Don Carlos',
    quote: 'En 2 meses duplicamos las citas online'
  }, {
    stat: '+65%',
    business: 'Veterinaria Xochimilco',
    quote: 'Google nos encuentra primero ahora'
  }, {
    stat: '3x',
    business: 'Pizzería Roma',
    quote: 'Triplicamos los pedidos por Instagram'
  }];
  return <section id="casos-de-exito" className="py-20 lg:py-24 bg-dark text-white" data-id="element-159">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
        <div className="text-center mb-16" data-id="element-161">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-white" data-id="element-162">
            Resultados que hablan solos
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-163">
          {cases.map((item, index) => <motion.div key={item.business} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-[#2A2A2E] border border-white/10 rounded-xl p-8 flex flex-col" data-id="element-164">
              <div className="text-5xl font-bold text-accent mb-4 font-heading tracking-tight" data-id="element-165">
                {item.stat}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-166">
                {item.business}
              </h3>
              <p className="text-gray-400 italic leading-relaxed flex-1" data-id="element-167">
                "{item.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}